




























































































// @ is an alias to /src
import Vue from 'vue';
import VueTagsInput from '@johmun/vue-tags-input';
import MotionSearchView from '@/components/MotionSearchView.vue';
import ApiRequest from '@/util/apiRequest';

import { API_MOTION_SEARCH, API_GET_CATEGORIES, API_TAG_QUERY } from '../../util/config';

export default Vue.extend({
  name: 'home',
  data() {
    return {
      categorySearch: '',
      categories: [],
      selectedCategories: [],
      tagSearch: '',
      selectedTags: [],
      filteredTags: [],
      tagDebounce: null,
      lastTagQuery: undefined,
      tagsExclusive: false,
      query: {},
      suitabilityMode: 0,
      uncategorisedSuitability: false,
      difficultyNoviceSchools: true,
      difficultyNoviceUni: true,
      difficultyIntermediate: true,
      difficultyAdvanced: true,
      difficultyUncategorised: true,
    };
  },
  components: {
    MotionSearchView,
    VueTagsInput,
  },
  methods: {
    async getCategories() {
      const response = await ApiRequest.Get(API_GET_CATEGORIES);
      this.$data.categories = response;
    },
    updateTagSearch(newTags : any) {
      this.$data.selectedTags = newTags;
      this.$data.filteredTags = [];
      this.$data.lastTagQuery = undefined;
    },
    async runTagSearch() {
      if (this.$data.tagSearch.length < 2) return;

      clearTimeout(this.$data.tagDebounce);
      this.$data.tagDebounce = setTimeout(async () => {
        if (this.$data.lastTagQuery !== this.$data.tagSearch) {
          this.$data.lastTagQuery = this.$data.tagSearch;
          const response = await ApiRequest.Get(API_TAG_QUERY
            + encodeURIComponent(this.$data.tagSearch));
          this.$data.filteredTags = response.map((tag: any) => ({ id: tag.id, text: tag.name }));
        }
      }, 600);
    },
    async runSearch() {
      const difficulties = [];
      if (this.$data.difficultyUncategorised) difficulties.push(0);
      if (this.$data.difficultyNoviceSchools) difficulties.push(1);
      if (this.$data.difficultyNoviceUni) difficulties.push(2);
      if (this.$data.difficultyIntermediate) difficulties.push(3);
      if (this.$data.difficultyAdvanced) difficulties.push(4);

      this.$data.query = {
        categories: this.$data.selectedCategories.map(cat => cat.id),
        tags: this.$data.selectedTags.map(tag => tag.id),
        allTags: this.$data.tagsExclusive,
        suitabilityMode: parseInt(this.$data.suitabilityMode, 10),
        suitabilityIncludeUncategorised: this.$data.uncategorisedSuitability,
        difficulties,
      };
    },
  },
  computed: {
    filteredCategories() {
      return this.$data.categories.filter(
        (cat : any) => cat.name.startsWith(this.$data.categorySearch),
      ).map((category: any) => ({ id: category.id, text: category.name }));
    },
  },
  watch: {
    tagSearch: 'runTagSearch',
  },
  mounted() {
    this.getCategories();
    this.runTagSearch();
  },
});
